import { useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

export default function useSmoothScrollPolyfill() {
   useEffect(() => {
      // aplicamos el polyfill para los metodos de scrollTo, scrollBy, etc
      smoothscroll.polyfill();
   }, []);
}
